export function defaultAccountingDate(entries = [], invoiceDate = '') {
  if (invoiceDate) return String(invoiceDate).slice(0,10);
  const dates = [...new Set(entries
    .filter(row => Number(row.debit || 0) !== 0 || Number(row.credit || 0) !== 0)
    .map(row => String(row.entry_date || '').slice(0,10)).filter(Boolean))];
  return dates.length === 1 ? dates[0] : String(invoiceDate || '').slice(0,10);
}

export function retentionTaxType(accountCode) {
  const code = String(accountCode || '').trim();
  if (!/^236[578]\d{4}$/.test(code)) return null;
  return { '2365': 'withholding', '2367': 'reteiva', '2368': 'reteica' }[code.slice(0,4)];
}

export function fiscalTaxType(accountCode) {
  return retentionTaxType(accountCode) || (/^240[89]\d{4}$/.test(String(accountCode || '').trim()) ? 'iva' : null);
}

export function validateManualRetention(row) {
  if (fiscalTaxType(row.account_code) && Math.abs(Number(row.credit || 0)-Number(row.debit || 0)) > 0 &&
      (!Number.isFinite(Number(row.base_amount)) || Number(row.base_amount) === 0)) {
    return 'El impuesto o retención tiene importe pero no tiene una base válida. Complete Valor Base (Impuestos).';
  }
  return '';
}
